<template>
  <!-- Match status of a backup record vs the current system. -->
  <span class="bk-badge-wrap">
    <span class="bk-badge" :class="`bk-badge--${(status || '').toLowerCase()}`"
          v-b-tooltip.hover.top="tooltip">
      <i :class="meta.icon"></i>
      <span>{{ bkStatusLabel(status) }}</span>
    </span>
    <a v-if="showCurrent && currentId != null && currentId !== ''" href="#" class="bk-badge-current no-click"
       :class="{ 'is-link': !!openClientId }"
       v-b-tooltip.hover.top="openClientId ? $t('backup.openCurrentClient') : $t('backup.currentId')"
       @click.prevent.stop="onCurrentClick">
      <i v-if="openClientId" class="fa-solid fa-arrow-up-right-from-square"></i>
      #{{ currentId }}
    </a>
  </span>
</template>

<script>
import mixinBackup, { STATUS_META } from '@/components/mixin/mixinBackup'
import mixinBase from '@/components/mixin/mixinBase'

export default {
  name: 'BackupStatusBadge',
  mixins: [mixinBase, mixinBackup],
  props: {
    status: { type: String, default: null },
    reason: { type: String, default: null },
    currentId: { default: null },
    // Current client id to open in the client modal (for EXISTS/CHANGED links).
    clientId: { default: null },
    showCurrent: { type: Boolean, default: true },
  },
  computed: {
    meta() {
      return STATUS_META[this.status] || { variant: 'secondary', icon: 'fa-solid fa-circle' }
    },
    openClientId() {
      return this.clientId != null && this.clientId !== '' ? this.clientId : null
    },
    tooltip() {
      const hint = this.bkT(`backup.statusHint.${this.status}`, '')
      const reason = this.reason && this.reason !== 'NONE'
        ? `${this.$t('backup.matchedBy')}: ${this.bkReasonLabel(this.reason)}` : ''
      return [hint, reason].filter(Boolean).join(' — ')
    },
  },
  methods: {
    onCurrentClick() {
      if (this.openClientId) this.showClient(this.openClientId)
    },
  },
}
</script>

<style scoped lang="scss">
.bk-badge-wrap { display: inline-flex; align-items: center; gap: 0.35rem; white-space: nowrap; }
.bk-badge {
  display: inline-flex; align-items: center; gap: 0.3rem;
  padding: 0.18rem 0.55rem; border-radius: 999px;
  font-size: 0.72rem; font-weight: 700; letter-spacing: 0.02em; line-height: 1.3;
  border: 1px solid transparent;
  i { font-size: 0.7rem; }

  &--missing { color: #7367f0; background: rgba(115, 103, 240, 0.12); border-color: rgba(115, 103, 240, 0.25); }
  &--id_conflict { color: #e8862a; background: rgba(255, 159, 67, 0.15); border-color: rgba(255, 159, 67, 0.4); }
  &--changed { color: #00b8cf; background: transparent; border-color: rgba(0, 207, 232, 0.55); }
  &--exists { color: #8a8d99; background: rgba(130, 134, 139, 0.1); }
  &--restored { color: #1f9d57; background: rgba(40, 199, 111, 0.14); border-color: rgba(40, 199, 111, 0.3); }
}
.bk-badge-current {
  font-size: 0.72rem; font-weight: 700; color: #8a8d99; text-decoration: none;
  i { font-size: 0.62rem; margin-right: 0.1rem; }
  &.is-link { color: #7367f0; }
  &.is-link:hover { text-decoration: underline; }
}

body.dark-layout {
  .bk-badge--exists { color: #a3a6b4; background: rgba(255, 255, 255, 0.06); }
  .bk-badge--missing { color: #a39cf6; }
  .bk-badge--id_conflict { color: #ffb36b; }
  .bk-badge--restored { color: #48da89; }
}
</style>
